import { useEffect, useMemo, useState } from 'react';
import { getFormStructure } from '../../api/requests/dynamicForm';
import Loading from '../info/Loading';
import DynamicFormBase, { DynamicFormBaseProps } from './DynamicFormBase';

interface DynamicFormProps extends Omit<DynamicFormBaseProps, 'structure'> {
  dynamicFormId: number;
  readOnly?: boolean;
}

function DynamicForm({ dynamicFormId, ...props }: DynamicFormProps) {
  const [structure, setStructure] = useState<any>([]);

  const dynamicFormUrl: Record<number, string> = useMemo(() => {
    return {
      // student file
      1: 'maintainers-portal/tuition-process-steps/student-file/form-structure',
      // sustainer file
      2: 'maintainers-portal/tuition-process-steps/sustainer/form-structure',
      // personal file
      3: 'maintainers-portal/teacher-file/personal-background/form-structure',
    };
  }, []);

  useEffect(() => {
    async function fetchFormularioConfig() {
      try {
        //obtenemos la estructura del formulario: 1 student file, 2 sustainer
        const formStructure = await getFormStructure(
          dynamicFormUrl[dynamicFormId],
        );
        setStructure(formStructure.data.sections);
      } catch (error) {
        console.error('Error al cargar la configuración del formulario', error);
      }
    }
    fetchFormularioConfig();
  }, [dynamicFormId, dynamicFormUrl]);

  if (!structure) {
    return <Loading insideCard textBody={'Cargando formulario'} />;
  }

  return <DynamicFormBase {...props} structure={structure} />;
}
export default DynamicForm;
